// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';
import { TAG_NAMES, FONT_COLOR, TEXT_ALIGN, HEADING_COLORS, TEXT_TRANSFORM } from '../Base/Base';

import { StyledHeadingSixth } from './HeadingSixth.styles';
import { ReactChildrenPropType } from '../../../../lib/commonPropTypes';

function HeadingSixth({ tagName, color, children, align, noMargins, className, textTransform }) {
  return (
    <StyledHeadingSixth
      tagName={tagName}
      color={HEADING_COLORS[color]}
      align={align}
      noMargins={noMargins}
      className={className}
      textTransform={textTransform}
    >
      {children}
    </StyledHeadingSixth>
  );
}

HeadingSixth.propTypes = {
  /** Font Color: primary, secondary, tertiary, quaternary */
  color: PropTypes.oneOf(FONT_COLOR),
  /** Element tag name: h1, h2, h3, h4, h5, h6, div, span, label, p, strong, li */
  tagName: PropTypes.oneOf(TAG_NAMES),
  /** Copy alignment: inherit, left, center, right, justify */
  align: PropTypes.oneOf(TEXT_ALIGN),
  /** Text Transform: none, capitalize, uppercase, lowercase, initial, inherit */
  textTransform: PropTypes.oneOf(TEXT_TRANSFORM),
  /** Copy/elements you want inside */
  children: ReactChildrenPropType,
  /** Remove default margins */
  noMargins: PropTypes.bool,
  /** Allows component to be overwritten by StyledComponents */
  className: PropTypes.string
};

HeadingSixth.defaultProps = {
  color: 'primary',
  tagName: 'div',
  align: 'left',
  textTransform: 'none',
  children: null,
  noMargins: false,
  className: ''
};

export default HeadingSixth;
